module.exports = __webpack_public_path__ + "img/Jakob.cafcc46d.png";